$(window).on('scroll resize', function () {
    var $box = $('.parallax-box');
    var $wrap = $box.find('.parallax-wrap');

    if ($(window).width() >= 1024) {
        var boxTop = $box.offset().top;
        var boxBottom = boxTop + $box.outerHeight();
        var scrollTop = $(window).scrollTop();
        var wrapHeight = $wrap.outerHeight();

        if (scrollTop > boxTop && scrollTop + wrapHeight < boxBottom) {
            $wrap.css({
                position: 'fixed',
                top: 0,
                width: $box.width()
            });
        } else if (scrollTop + wrapHeight >= boxBottom) {
            $wrap.css({
                position: 'absolute',
                top: $box.outerHeight() - wrapHeight,
                width: '100%'
            });
        } else {
            $wrap.css({
                position: 'absolute',
                top: 0,
                width: '100%'
            });
        }
    } else {
        $wrap.css({
            position: '',
            top: '',
            width: ''
        });
    }
});